export default "__VITE_ASSET__CkLSIwTY__"